<template>
    <div :disabled="notLoaded" class="core-wrapper split">
        <div v-if="notLoaded" class="spinner">
            <font-awesome-icon icon="spinner" size="6x" spin></font-awesome-icon>
        </div>
        <div id="viz">
            <div id="canvas-container" class="emscripten-border">
                <canvas class="emscripten" tabindex='1' id="canvas" oncontextmenu="event.preventDefault()"></canvas>
<!--                <InsertionMenu :items="getDeletedDimensions"></InsertionMenu>-->
            </div>
        </div>
        <div id="table" class="p-3">
            <Table :items=currentItems :height="tableHeight"></Table>
        </div>
    </div>
</template>

<script>
    import Table from "./Table";
    import split from 'split.js';
    import {mapGetters} from 'vuex';
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
    // import InsertionMenu from "./InsertionMenu";

    export default {
        name: "Main",
        components: {
            // InsertionMenu,
            Table,
            FontAwesomeIcon
        },
        data() {
            return {
                progress: 0,
                sizes: [50, 50],
                split: null,
                tableHeight: 0
            };
        },
        mounted() {
            this.changeCanvasSize()
            // module.canvas.removeEventListener('keydown');
            this.sizes = [50, 50];  // default sizes
            this.split = split(['#viz', '#table'], {
                sizes: this.sizes,
                minSize: 200,
                onDragEnd: this.changeCanvasSize,
                direction: 'vertical',
                elementStyle(dimension, size, gutterSize) {
                    return {
                        'flex-basis': 'calc(' + size + '% - ' + gutterSize + 'px)'
                    };
                },
                gutterStyle(dimension, gutterSize) {
                    return {
                        'flex-basis': gutterSize + 'px'
                    };
                }
            });
        },
        computed: {
            notLoaded() {
                return (this.progress > 0 && this.progress < 100) ||
                    (this.loadingProgress > 0 && this.loadingProgress < 100);
            },
            currentItems() {
                if (this.activeSelection) {
                    return this.getSelection
                } else {
                    return this.getDataTable
                }
            },
            // mix the getters into computed with object spread operator
            ...mapGetters(['loadingProgress', 'getSelection', 'activeSelection', 'getDataTable', 'getDeletedDimensions'])
        },
        methods: {
            clickCanvas() {
                // this.progress = 50;
                // console.log(this.notLoaded);
                // this.$store.commit('makeSelectionDirty');
            },
            changeCanvasSize() {
                // localStorage.setItem('split-sizes', JSON.stringify(this.split.getSizes()));
                this.$store.commit('resize');
                let wrapper = document.getElementsByClassName("split")[0]
                let otherComponent = document.getElementById("viz")
                if (wrapper && otherComponent)
                    this.tableHeight = wrapper.offsetHeight - otherComponent.offsetHeight
                else
                    this.tableHeight = 0
            }
        }
    };
</script>

<style lang="less">
    /* the canvas *must not* have any border or padding, or mouse coords will be wrong */
    canvas.emscripten {
        padding-right: 0;
        margin-left: auto;
        margin-right: auto;
        display: block;
        height: 100%;
        width: 100%;
        order: 0;
        background-color: white;
    }

    .gutter {
        cursor: ns-resize !important;
        border-bottom-width: 1px;
        border-bottom-color: gray;
        border-bottom-style: dashed;
    }

    .emscripten-border {
        background-color: grey;
        width: 100%;
        height: 100%;
        overflow: auto;
    }

    .core-wrapper {
        width: 100%;
        max-width: 100%;
        height: calc(100vh - 74px);
        max-height: calc(100vh - 74px);
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    #viz, #table {
        width: 100%;
        max-width: 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .spinner {
        position: absolute;
        left: 50%;
        top: 50%;
        height: 60px;
        width: 60px;
        margin: 0 auto;
        z-index: 100;
    }


</style>
